export default "__VITE_ASSET__C6Ji22f0__"